export const objectives = [
	{
		key: 'awareness',
		value: 'awareness',
		description:
			'Make potential customers become more familiar with your business',
		html: '<p><strong>Awareness:</strong> Get customers familiar with your business.</p>',
	},
	{
		key: 'traffic',
		value: 'traffic',
		description: 'Drive traffic to a destination',
		html: '<p><strong>Traffic:</strong> Send people to your site or destination.</p>',
	},
	{
		key: 'engagement',
		value: 'engagement',
		description: 'Drive valuable actions',
		html: '<p><strong>Engagement:</strong> Encourage customers to take action.</p>',
	},
	{
		key: 'leads',
		value: 'leads',
		description: 'Collect leads for your business',
		html: '<p><strong>Leads:</strong> Capture contact info for potential customers.</p>',
	},
	{
		key: 'sales',
		value: 'sales',
		description: 'Sell your product or service',
		html: '<p><strong>Sales:</strong> Convert customers to buy your product or service.</p>',
	},
];

export const awareness = [
	{
		key: 'L1',
		value: 'L1',
		title: 'Unaware',
		description:
			'Customers are not aware of the product, service, or even the problem it solves. Marketing efforts here are focused on creating awareness about the problem or need.',
		html: '<p><strong>1) Unaware:</strong> Customers don’t know you or the problem yet. Create awareness.</p>',
	},
	{
		key: 'L2',
		value: 'L2',
		title: 'Problem aware',
		description:
			"Customers are aware they have a problem or need, but they don't know that there is a solution. Marketing at this stage should educate about the solutions available.",
		html: '<p><strong>2) Problem aware:</strong> Customers see the problem but not the solution. Educate them.</p>',
	},
	{
		key: 'L3',
		value: 'L3',
		title: 'Solution aware',
		description:
			'Customers know solutions exist but are not aware of your specific product or service. The focus here is on introducing your product as a viable solution.',
		html: '<p><strong>3) Solution aware:</strong> Customers know solutions exist. Show why yours works.</p>',
	},
	{
		key: 'L4',
		value: 'L4',
		title: 'Product / brand aware',
		description:
			'Customers are aware of your product or brand but aren’t convinced it’s right for them. Here, marketing should emphasize the benefits and advantages of your product over competitors.',
		html: '<p><strong>4) Product / brand aware:</strong> Customers know your product. Prove it’s better.</p>',
	},
	{
		key: 'L5',
		value: 'L5',
		title: 'Most aware',
		description:
			'Customers are fully aware of your product and its benefits, and they just need a nudge to make the purchase. This is where you focus on prices, offers, guarantees, or other incentives to close the sale.',
		html: '<p><strong>5) Most aware:</strong> Customers are ready. Use offers or guarantees to close.</p>',
	},
];

export const sophistication = [
	{
		key: 'L1',
		value: 'L1',
		title: 'Introduction',
		description:
			'The pioneering phase of a product or service, where there is no competition. Marketing should be simple, direct, and focused on naming the need or the claim.',
		html: '<p><strong>1) Introduction:</strong> No competition. Keep marketing simple and direct.</p>',
	},
	{
		key: 'L2',
		value: 'L2',
		title: 'Feature Emphasis',
		description:
			"Competition starts catching up in this stage, necessitating more detailed claims. The strategy involves enlarging and driving the product's claims to their limits to outbid the competition.",
		html: '<p><strong>2) Feature Emphasis:</strong> Competition rises. Make bold, detailed claims.</p>',
	},
	{
		key: 'L3',
		value: 'L3',
		title: 'Mechanism Introduction',
		description:
			'The market is now familiar with the product type and traditional claims are no longer effective. A new mechanism or method to make old promises work and appear fresh is required.',
		html: '<p><strong>3) Mechanism Introduction:</strong> Old claims fade. Highlight a new method.</p>',
	},
	{
		key: 'L4',
		value: 'L4',
		title: 'Overcoming Competition',
		description:
			"The competition is sophisticated, making bigger and bolder claims. The focus shifts to elaborating and enhancing the product's mechanism, making it more efficient and promising additional benefits.",
		html: '<p><strong>4) Overcoming Competition:</strong> Competitors push harder. Enhance your mechanism with extra benefits.</p>',
	},
	{
		key: 'L5',
		value: 'L5',
		title: 'Identity Focus',
		description:
			'The market becomes skeptical due to overexposure to claims. Marketing shifts from promises and mechanisms to identification with the prospect, appealing to their identity rather than just desires.',
		html: '<p><strong>5) Identity Focus:</strong> Market is skeptical. Appeal to customer identity, not just claims.</p>',
	},
];

export const frameworks = [
	{
		name: 'AIDA',
		full_form: 'Attention, Interest, Desire, Action',
	},
	{
		name: 'PAS',
		full_form: 'Pain, Agitate, Solve',
	},
	{
		name: 'FAB',
		full_form: 'Features, Advantages, Benefits',
	},
	{
		name: 'USP',
		full_form: 'Unique Selling Proposition',
	},
	{
		name: 'EMPATH',
		full_form: 'Engage, Motivate, Promote, Acknowledge, Tailor, Highlight',
	},
	{
		name: 'SEP',
		full_form: 'Story, Emotion, Point',
	},
	{
		name: '4Ps',
		full_form: 'Picture, Promise, Proof, Push',
	},
	{
		name: 'BAB',
		full_form: 'Before-After-Bridge',
	},
	{
		name: 'PAPA',
		full_form: 'Problem, Agitate, Persuade, Asks',
	},
	{
		name: '4Us',
		full_form: 'Useful, Urgent, Unique, Ultra-specific',
	},
];

export const desires = [
	'Love',
	'Happiness',
	'Success',
	'Wealth',
	'Health',
	'Freedom',
	'Adventure',
	'Knowledge',
	'Recognition',
	'Influence',
	'Amusement',
	'Schadenfreude',
	'Sensory Pleasure',
	'Serenity',
	'Relief',
	'Satisfaction',
	'Euphoria',
	'Happy-for',
	'Lust',
	'Affection',
	'Enjoyment',
	'Prestige',
	'Competition',
	'Autonomy',
	'Order',
	'Simplicity',
	'Environmental Care',
	'Curiosity',
	'Community',
];

export const emotions = [
	'Amusement',
	'Schadenfreude',
	'Sensory Pleasure',
	'Serenity',
	'Relief',
	'Satisfaction',
	'Euphoria',
	'Happy-for',
	'Lust',
	'Affection',
	'Prestige',
	'Competition',
	'Autonomy',
	'Order',
	'Simplicity',
	'Environmental Care',
	'Curiosity',
	'Community',
	'Awe',
	'Excitement',
	'Hope',
	'Joy',
	'Curiosity',
	'Confidence',
	'Empathy',
	'Compassion',
	'Trust',
];
